import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ComponentsModule } from '../components/components.module';
import { BuiltInModule } from '../built-in/built-in.module';
import { PipesModule } from '../pipes/pipes.module';

import { ComparisonReportComponent } from './components/comparison-report/comparison-report.component';
import { CreditCardReportComponent } from './components/credit-card-report/credit-card-report.component';
import { CreditReportComponent } from './components/credit-report/credit-report.component';
import { DeclinedReportComponent } from './components/declined-report/declined-report.component';
import { DiscountReportComponent } from './components/discount-report/discount-report.component';
import { DisputeReportSearchComponent } from './components/dispute-report-search/dispute-report-search.component';
import { DisputeReportComponent } from './components/dispute-report/dispute-report.component';
import { DonationReportComponent } from './components/donation-report/donation-report.component';
import { ExpiredReportComponent } from './components/expired-report/expired-report.component';
import { FinancialsReportComponent } from './components/financials-report/financials-report.component';
import { IncompleteReportComponent } from './components/incomplete-report/incomplete-report.component';
import { LocationReportComponent } from './components/location-report/location-report.component';
import { TopCounterTeamRegistrationComponent } from './components/partial/top-counter-team-registration/top-counter-team-registration.component';
import { TopCounterComponent } from './components/partial/top-counter/top-counter.component';
import { PastDueReportComponent } from './components/past-due-report/past-due-report.component';
import { PayoutReportComponent } from './components/payout-report/payout-report.component';
import { ReconciliationReportComponent } from './components/reconciliation-report/reconciliation-report.component';
import { RefundReportComponent } from './components/refund-report/refund-report.component';
import { RemovedBallancesReportComponent } from './components/removed-ballances-report/removed-ballances-report.component';
import { ScholershipReportSearchComponent } from './components/scholership-report-search/scholership-report-search.component';
import { ScholershipReportComponent } from './components/scholership-report/scholership-report.component';
import { SponsorshipReportComponent } from './components/sponsorship-report/sponsorship-report.component';
import { TeamRegistrationReportComponent } from './components/team-registration-report/team-registration-report.component';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    PipesModule,
    BuiltInModule,
  ],
  declarations: [
    ComparisonReportComponent,
    CreditReportComponent,
    ScholershipReportComponent,
    DisputeReportSearchComponent,
    ScholershipReportSearchComponent,
    TopCounterComponent,
    TopCounterTeamRegistrationComponent,
    DeclinedReportComponent,
    DisputeReportComponent,
    DiscountReportComponent,
    ExpiredReportComponent,
    IncompleteReportComponent,
    PastDueReportComponent,
    RefundReportComponent,
    CreditCardReportComponent,
    LocationReportComponent,
    PayoutReportComponent,
    TeamRegistrationReportComponent,
    FinancialsReportComponent,
    ReconciliationReportComponent,
    DonationReportComponent,
    SponsorshipReportComponent,
    RemovedBallancesReportComponent,
  ],
  exports: [
    ComparisonReportComponent,
    CreditReportComponent,
    ScholershipReportComponent,
    DisputeReportSearchComponent,
    ScholershipReportSearchComponent,
    TopCounterComponent,
    TopCounterTeamRegistrationComponent,
    DeclinedReportComponent,
    DisputeReportComponent,
    DiscountReportComponent,
    ExpiredReportComponent,
    IncompleteReportComponent,
    PastDueReportComponent,
    RefundReportComponent,
    CreditCardReportComponent,
    LocationReportComponent,
    PayoutReportComponent,
    TeamRegistrationReportComponent,
    FinancialsReportComponent,
    ReconciliationReportComponent,
    DonationReportComponent,
    SponsorshipReportComponent,
    RemovedBallancesReportComponent,
  ]
})
export class ClubprogramReportsModule { }



// WEBPACK FOOTER //
// ./src/app/shared/clubprogram-reports/clubprogram-reports.module.ts